export default "__VITE_ASSET__cd99e85f__"